import React, { useEffect, useRef } from 'react';
import '../css/review.css';

function Review() {
  const reviewSectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          reviewSectionRef.current.classList.add('visible');
        } else {
          reviewSectionRef.current.classList.remove('visible'); // Remove class when out of view
        }
      },
      { threshold: 0.1 }
    );

    if (reviewSectionRef.current) {
      observer.observe(reviewSectionRef.current);
    }

    return () => {
      if (reviewSectionRef.current) {
        observer.unobserve(reviewSectionRef.current);
      }
    };
  }, []);

  const reviews = [
    {
      // Removed invalid style property
      name: 'Allied Hospital Faisalabad',
      text: 'Clean World Environmental Solutions transformed our hospital waste program. Their team provided rapid, fully compliant pickup and secure disposal of regulated medical waste, supplied clear audit-ready documentation, and handled each step with exceptional professionalism. Their emergency response and affordable, sustainable solutions make them our trusted partner.',
      rating: 5,
      reviewsCount: '',
      style: { textAlign: 'justify' },
    },
    {
      name: 'DHQ Hospital Faisalabad',
      text: 'Exceptional service — Clean World delivered timely, safe, and environmentally responsible removal of hazardous and non-hazardous waste from our facility. Their compliance expertise and transparent reporting gave our infection control team complete confidence. Outstanding communication and on-site professionalism.',
      rating: 5,
      reviewsCount: '',
      style: { textAlign: 'justify' },
    },
    {
      name: 'Faisalabad Institute of Cardiology',
      text: 'Clean World consistently exceeds expectations. They managed complex regulated waste streams, provided tailored staff training, and ensured full chain-of-custody documentation. Their sustainability initiatives and prompt emergency response have made them indispensable to our hospital operations.',
      rating: 5,
      reviewsCount: '',
      style: { textAlign: 'justify' },
    },
  ];

  return (
    <div ref={reviewSectionRef} className="review-section">
      <h2 className="review-title">What our customers say</h2>
      <div className="review-container" style={{ textAlign: 'justify' }}>
        {reviews.map((review, index) => (
          <div key={index} className="review-card" >
            <div className="review-rating">
              {'★'.repeat(review.rating)}
            </div>
            <p className="review-text">{review.text}</p>
            <div className="review-author">
              <div className="review-author-icon">
                <svg
                  width="40"
                  height="40"
                  fill="#7cb518"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 12c2.7 0 8 1.34 8 4v2H4v-2c0-2.66 5.3-4 8-4zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2c-2.67 0-8 1.34-8 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>
              <div>
                <span className="review-author-name">{review.name}</span>
                <span className="review-author-details">{review.reviewsCount}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Review;